import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31fc54e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photo-wrapper" }
const _hoisted_2 = { class: "photo h-58" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = { class: "nav-buttons" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-info" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-edit" }, null, -1))
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "header-top" }
const _hoisted_10 = { class: "header--center" }
const _hoisted_11 = { class: "header--left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_13 = { class: "header__title" }
const _hoisted_14 = { class: "header--right" }
const _hoisted_15 = {
  key: 0,
  class: "icon-box"
}
const _hoisted_16 = {
  key: 1,
  class: "spacer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_small_loader = _resolveComponent("app-small-loader")!
  const _component_v_zoomer = _resolveComponent("v-zoomer")!
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!
  const _component_app_cropper = _resolveComponent("app-cropper")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_media_settings_pop_up = _resolveComponent("media-settings-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.disableSwipe)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchPage('LEFT'))),
            class: "switcher switcher-left"
          }))
        : _createCommentVNode("", true),
      (_ctx.photoLoading)
        ? (_openBlock(), _createBlock(_component_app_small_loader, {
            key: 1,
            whiteSpinner: ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_zoomer, {
        style: {"width":"100%","height":"100%"},
        maxScale: 10,
        aspectRatio: _ctx.aspectRatio
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("img", {
            ref: "imageRef",
            src: _ctx.mainPhoto,
            onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.photoLoaded && _ctx.photoLoaded(...args))),
            alt: ""
          }, null, 40, _hoisted_3), [
            [_vShow, !_ctx.photoLoading]
          ])
        ]),
        _: 1
      }, 8, ["aspectRatio"]),
      (!_ctx.disableSwipe)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPage('RIGHT'))),
            class: "switcher switcher-right"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "nav-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPopUp(_ctx.BOTTOM_POPUP_TYPES.PHOTO_INFO_OLD)))
        }, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.info')), 1)
        ]),
        (!_ctx.isNetwork && !_ctx.viewOnly)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCropper && _ctx.openCropper(...args)), ["prevent"])),
              class: "nav-btn"
            }, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.edit')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              class: "back-link white",
              href: "javascript:void(0);",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$localize('photo.view.backtext')), 1)
            ])
          ]),
          _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.driveStore.fullscreenPhoto!.name), 1),
          _createElementVNode("div", _hoisted_14, [
            (!_ctx.isNetwork && _ctx.isMy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{ hidden: _ctx.isCase }, "icon icon-share"]),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSharePopUp = true))
                  }, null, 2),
                  _createElementVNode("span", {
                    class: "icon icon-dots",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isMediaSettingsPopUp = true))
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16))
          ])
        ])
      ]),
      (!_ctx.isNetwork && _ctx.isMy)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "header-bottom",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isSharePopUp = true))
          }, [
            (!_ctx.isNetwork)
              ? (_openBlock(), _createBlock(_component_drive_shared_bar, {
                  key: 0,
                  onOnVisitChat: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_app_cropper, {
      image: _ctx.image,
      onOnCrop: _ctx.handleOnCrop,
      onOnCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.image = {})),
      "is-case-cropper": "",
      ref: "cropperRef",
      canvas: false
    }, null, 8, ["image", "onOnCrop"]),
    (_ctx.isSharePopUp)
      ? (_openBlock(), _createBlock(_component_share_pop_up, {
          key: 0,
          item: _ctx.driveStore.fullscreenPhoto!,
          "item-type": _ctx.SHARE_TYPES.PHOTO,
          onHide: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isSharePopUp = false)),
          onSetItemShared: _ctx.setItemShared,
          onSetSharedLabels: _ctx.setSharedLabels,
          onOnShareByMessage: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
        }, null, 8, ["item", "item-type", "onSetItemShared", "onSetSharedLabels"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_media_settings_pop_up, {
          key: 1,
          file: _ctx.driveStore.fullscreenPhoto!,
          type: _ctx.MEDIA_TYPES.PHOTO,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isMediaSettingsPopUp = false)),
          onCloseMedia: _cache[14] || (_cache[14] = ($event: any) => (_ctx.driveStore.fullscreenPhoto = undefined)),
          onOpenMovePopUp: _ctx.openMovePopUp,
          onDeleteMedia: _ctx.deletePhoto
        }, null, 8, ["file", "type", "onOpenMovePopUp", "onDeleteMedia"]))
      : _createCommentVNode("", true),
    (_ctx.isMoveToPopUp)
      ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
          key: 2,
          item: _ctx.driveStore.fullscreenPhoto!,
          "item-type": _ctx.SHARE_TYPES.PHOTO,
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isMoveToPopUp = false)),
          onUpdateLocation: _ctx.updateLocation
        }, null, 8, ["item", "item-type", "onUpdateLocation"]))
      : _createCommentVNode("", true)
  ]))
}